

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IpReportApi } from '../api/ip-report.api';
import { IpReportData, IpReport } from '../../../interfaces/report/ip-report';

@Injectable()
export class IpReportService extends IpReportData {

  constructor(private api: IpReportApi) {
    super();
  }

  searchList(url: string,data:any): Observable<any> { 
   
    return this.api.searchList(url,data);
  }
}
